import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./calendereventspage.css";
import { getFilteredEvents } from "./apiService";
import { FaThLarge, FaList } from "react-icons/fa";
import { Navigate, useNavigate } from "react-router-dom";

// ✅ Lists
const States = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Delhi", "Goa", "Gujarat",
    "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh",
    "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan",
    "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"
];

const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

const industries = [
    "Agriculture", "Animals & Pets", "Auto & Automotive", "Baby, Kids & Maternity", "Banking & Finance",
    "Building & Construction", "Business, Investment", "Consumer Goods", "Cosmetics", "Culture, Arts & Crafts",
    "Education & Career", "Electric & Electronics", "Entertainment & Media", "Environment & Waste",
    "Fashion & Accessories", "Food & Beverages", "Gems & Jewelry", "Home & Office", "Industrial Engineering",
    "IT & Technology", "Logistics & Transportation", "Marketing, Advertising, PR", "Medical & Pharma",
    "Metallurgy & Materials", "Packing & Packaging", "Power & Energy", "Real Estate & Property",
    "Science & Research", "Security & Defense", "Sports & Sporting", "Telecommunication & Media",
    "Travel & Tourism", "Wood & Paper"
];

const CalendarEventPage = () => {
    const [events, setEvents] = useState([]);
    const [isListView, setIsListView] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedValue, setSelectedValue] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        fetchEvents();
    }, [selectedValue]);

    const fetchEvents = async () => {
        try {
            const filters = {};
            if (selectedCategory === "State") filters.State = selectedValue;
            if (selectedCategory === "Month & Year") {
                const [month, year] = selectedValue.split("-");
                filters.month = month.padStart(2, "0");
                filters.year = year;
            }
            if (selectedCategory === "Department Type") filters.departmentType = selectedValue;

            console.log("Fetching events with filters:", filters);
            const data = await getFilteredEvents(filters);

            if (!data || data.length === 0) {
                setEvents([]);
                return;
            }

            const formattedEvents = data.map((event, index) => {
                if (!event.startDate) return null;

                const [year, month, day] = event.startDate.split("-");
                const shortMonth = months[parseInt(month, 10) - 1].slice(0, 3);
                const shortYear = year.slice(-2);
                let eventName = event.eventName || "Unnamed Event";

                // Truncate specific event name
                if (eventName.startsWith("Advantage Healthcare India 2024 (AHCI 2024) - 8th edition of International Summit on Medical")) {
                    eventName = "Advantage Healthcare India 2024 (AHCI 2024)";
                }
                return {
                    id: event.id || Math.random(),
                    date: day || "00",
                    month:month.padStart(2,"0"),
                    year:year,
                    monthYear: `${shortMonth}, ${shortYear}` || "Unknown",
                    eventName: eventName,
                    location: event.location || "No location available",
                    departmentType: event.departmentType || "N/A",
                    endDate: event.endDate,
                    link: event.link,
                    color: event.color || ["#ff7300", "#1588d4", "#1baf8f", "#d63f3f"][index % 4],
                };
            }).filter(event => event !== null);

            // ✅ Sort events chronologically (oldest to newest)
        formattedEvents.sort((a, b) => {
            const dateA = new Date(`${a.year}-${a.month}-${a.date}`);
            const dateB = new Date(`${b.year}-${b.month}-${b.date}`);
            return dateA - dateB;
        });

            setEvents(formattedEvents);
        } catch (error) {
            console.error("Error fetching events:", error);
            setEvents([]);
        }
    };
    const handleCalculate = (eventName) => {
        const fullEventName = eventName === "Advantage Healthcare India 2024 (AHCI 2024)"
            ? "Advantage Healthcare India 2024 (AHCI 2024) - 8th edition of International Summit on Medical"
            : eventName;
    
        navigate(`/newaddinfo?eventName=${encodeURIComponent(fullEventName)}`);
    };
    

    return (
        <div className="calevent-page">      
            <h1 className="caltitle">Upcoming Events</h1>
         
            {/* ✅ Category Selection */}
            <div className="filter-container">
                <select value={selectedCategory} onChange={(e) => {
                    setSelectedCategory(e.target.value);
                    setSelectedValue(""); // Reset second dropdown when category changes
                }}>
                    <option value="">Select Filter Type</option>
                    <option value="State">State</option>
                    <option value="Month & Year">Month & Year</option>
                    <option value="Department Type">Department Type</option>
                </select>

                {/* ✅ Second dropdown based on selection */}
                {selectedCategory && (
                    <select value={selectedValue} onChange={(e) => setSelectedValue(e.target.value)}>
                        <option value="">Select {selectedCategory}</option>
                        {selectedCategory === "State" && States.map(state => (
                            <option key={state} value={state}>{state}</option>
                        ))}

                        {selectedCategory === "Month & Year" && 
                            [...Array(3)].map((_, i) => {
                                const year = new Date().getFullYear() + i;
                                return months.map((month, index) => (
                                    <option key={`${month}-${year}`} value={`${index + 1}-${year}`}>
                                        {`${month} ${year}`}
                                    </option>
                                ));
                            })
                        }
                        
                        {selectedCategory === "Department Type" && industries.map(department => (  // ✅ Using industries array for departments
            <option key={department} value={department}>{department}</option>
        ))}
                    </select>
                )}

                <button className="view-toggle-btn" onClick={() => setIsListView(!isListView)}>
                    {isListView ? <FaThLarge size={30} /> : <FaList size={30} />}
                </button>
            </div>

            {/* ✅ Event Display */}
            {isListView ? (
                <div className="list-view">
                    {events.map(event => (
                        <div key={event.id} className="list-event-card" style={{ borderColor: event.color }}>
                            <div className="list-date" style={{ background: event.color }}>
                                <span className="list-day">{event.date}</span>
                                <span className="list-month">{event.monthYear.toUpperCase()}</span>
                            </div>
                            <div className="list-details">
                                <h2 style={{ color: event.color }}>{event.eventName}</h2>
                                <p><strong>Location:</strong> {event.location}</p>
                                <p><strong>Department:</strong> {event.departmentType}</p>                                                            
                                {event.link && (
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                        <div>
                                            <strong>Event Details</strong>
                                            <a
                                                href={event.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="event-link">
                                                Event Link
                                            </a>
                                            <button
                                                style={{
                                                    backgroundColor: event.color,
                                                    color: "#fff",
                                                    border: "none",
                                                    padding: "6px 12px",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    alignContent: "flex-end",
                                                    textAlign: "right",
                                                    marginLeft: "590px",
                                                    marginTop: "-50px"
                                                }}
                                           onClick={() => handleCalculate(event.eventName)}>
                                                Calculate Emission
                                            </button>
                                        </div>                                   
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                events.length > 0 ? (
                    <Swiper
                        spaceBetween={20}
                        slidesPerView={3}
                        navigation
                        pagination={{
                            clickable: true,
                            renderBullet: function (index, className) {
                                const maxDots = 15; // ✅ Set the maximum number of dots
                                return index < maxDots ? `<span class="${className}"></span>` : "";
                            }
                        }}
                        loop={true}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                        modules={[Pagination, Navigation, Autoplay]}
                        className="calevents-slider"
                    >
                        {events.map(event => (
                            <SwiperSlide key={event.id}>
                                <div className="calevent-card" style={{ borderColor: event.color }}>
                                    <div className="calevent-header" style={{ background: event.color }}>
                                        <span className="calevent-month">{event.monthYear.toUpperCase()} </span>
                                        <span className="calevent-date">{event.date}</span>
                                    </div>
                                  
                                        <div className="calevent-heading">
                                        <h1 style={{ color: event.color, marginTop: "20px" }}>{event.eventName}</h1>
                                        </div>
                                        
                                        <div className="calevent-body">
                                            <h4><strong>Location:</strong> {event.location}</h4>
                                            <h4><strong>Sector:</strong> {event.departmentType}</h4>
                                            
                                            {event.link && (
                                                <h4>
                                                    <a
                                                        href={event.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="event-link"
                                                    >
                                                        Event Details
                                                    </a>
                                                </h4>
                                            )}
                                        </div>
                                       <div className="calevent-body">
                                       <button className="calculate-button" style={{ background: event.color , border: '1px solid event.color'}} onClick={() => handleCalculate(event.eventName)}>
                                                Calculate Emission
                                            </button>
                                       </div>

                                </div>
                              
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <p className="no-events">Please select a filter</p>
                )
            )}
        </div>
    );
};

export default CalendarEventPage;
